<template>
  <Card>
    <template #title="">นโยบายความเป็นส่วนตัว</template>
    <template #subtitle=""></template>
    <template #content="">
      <div class="p-grid">
        <div class="p-col-12">
          <span v-html="pdpa"></span>
        </div>
      </div>
    </template>
    <template #footer="">
      <Button
        @click="onConsent"
        icon="pi pi-check"
        class="p-button-success"
        label="ยอมรับ"
      ></Button>
      <Button
        @click="onNotConsent"
        icon="pi pi-times"
        class="p-button-danger p-ml-2"
        label="ไม่ยอมรับ (ออกจากระบบ)"
      ></Button>
    </template>
  </Card>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { usePlugin } from "@/plugins";
import { GetPdpaMessageResponse, UserProfileDto } from "@/types";

export default defineComponent({
  name: "PdpaScreen",
  setup() {
    const {
      axios,
      setLoading,
      onRouterReplace,
      onLogout,
      dayjs,
      error,
      useSessionState,
    } = usePlugin();
    const pdpa = ref("");
    const updateOn = ref<Date>();
    const sessionState = useSessionState();
    const onConsent = async () => {
      setLoading(true);
      try {
        await axios.post("api/v1/services/pdpa/consent", {});
        // store.commit("setProfile", {
        //   ...store.state.profile,
        //   isPdpaAccepted: true,
        // } as UserProfileDto);
        sessionState.value.profile.isPdpaAccepted = true;
        await onRouterReplace({ name: "home" });
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };
    const onNotConsent = () => {
      onLogout();
    };

    const loadDocument = async () => {
      setLoading(true);
      try {
        const result = await axios.get<GetPdpaMessageResponse>(
          "api/v1/services/pdpa"
        );
        pdpa.value = result.data.message ?? "ไม่พบข้อมูล PDPA";
        updateOn.value = result.data.updateOn ?? dayjs().toDate();
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    onMounted(() => loadDocument());

    return {
      pdpa,
      onConsent,
      onNotConsent,
    };
  },
});
</script>

<style></style>
